export const resumeLink =
  "https://drive.google.com/file/d/1k4Sow6wfv0uAvqC4VB9e9M29ZRRmoB8E/view";
